module.exports = __webpack_public_path__ + "img/g2w-logo.a5e4fbaa.svg";